import { useLocation } from 'react-router-dom'
import { useIsMobileOrTablet } from 'hooks/useIsMobileOrTablet'
import { hasSiteFooter } from './hasSiteFooter'

export function useHasSiteFooter(): boolean {
  const { pathname } = useLocation()
  return hasSiteFooter(pathname, useIsMobileOrTablet())
}
